import React from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, TimePickerField, SelectField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";

const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function Form({ data, ...rest }) {
    const validationSchema = Yup.object({
        dayOfWeek: Yup.string().oneOf(dayNames, "This is not a valid week day").required("Required field"),
        startTime: Yup.date("Invalid time. e.g. 08:00").required("Required field"),
        endTime: Yup.date("Invalid time. e.g. 17:00").required("Required field"),
    });

    return (
        <FormikForm initialValues={data} validationSchema={validationSchema} {...rest}>
            <div className="layout">
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <FormControl component="fieldset">
                            <FormGroup row>
                                <SelectField
                                    fieldName="dayOfWeek"
                                    label="Day of Week *"
                                    options={dayNames.map((o) => ({ value: o, label: o }))}
                                />
                                <TimePickerField fieldName="startTime" label="Start Time *" placeholder="08:00" />
                                <TimePickerField fieldName="endTime" label="End Time *" placeholder="17:00" />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.shape({
        dayOfWeek: PropTypes.oneOf(dayNames),
        startTime: PropTypes.instanceOf(Date),
        endTime: PropTypes.instanceOf(Date),
    }),
};

Form.defaultProps = {
    data: { dayOfWeek: dayNames[1], startTime: new Date(), endTime: new Date() },
};

export default Form;
